import { Injectable, HostListener } from "@angular/core";
import { BehaviorSubject, Observable, Subscriber } from "rxjs";

// Menu
export interface Menu {
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  perfil?: string[];
}

@Injectable({
  providedIn: "root",
})
export class NavService {
  public screenWidth: any;
  public collapseSidebar: boolean = false;
  public fullScreen = false;

  constructor() {
    this.onResize();
    if (this.screenWidth < 991) {
      this.collapseSidebar = true;
    }
  }

  // Windows width
  @HostListener("window:resize", ["$event"])
  onResize(event?: any) {
    this.screenWidth = window.innerWidth;
  }

  MENUITEMS: Menu[] = [
    {
      title: "Dashboard",
      icon: "bar-chart",
      type: "sub",
      active: false,
      children: [
        {
          path: "dashboard/atendimento",
          icon: "file-text",
          title: "Atendimentos",
          type: "link",
          perfil: ["1", "7"],
        },
        {
          path: "dashboard/financeiro",
          icon: "dollar-sign",
          title: "Financeiro",
          type: "link",
          perfil: ["1", "7"],
        },
        {
          path: "dashboard/porsistema",
          icon: "dollar-sign",
          title: "Por Sistema",
          type: "link",
        },
        {
          path: "dashboard/pordemandante",
          icon: "dollar-sign",
          title: "Por Demandante",
          type: "link",
        },
        {
          path: "dashboard/porresponsavel",
          icon: "dollar-sign",
          title: "Por Responsável",
          type: "link",
        },
        {
          path: "dashboard/portempoaberto",
          icon: "dollar-sign",
          title: "Tempo em Aberto",
          type: "link",
        },
        {
          path: "dashboard/evolucaomensal",
          icon: "bar-chart",
          title: "Evolução Mensal de Atendimentos",
          type: "link",
        },
      ],
    },
    {
      title: "Gestão da Cidade",
      icon: "file-text",
      type: "sub",
      active: false,
      children: [
        {
          path: "clientediagnostico",
          icon: "file-text",
          title: "Informação por Município",
          type: "link",
        },
        {
          path: "painelcidade",
          icon: "file-text",
          title: "Painel da Cidade",
          type: "link",
        }
      ],
    },
    // {
    //   path: "/atendimentos/listar",
    //   icon: "file-text",
    //   title: "Atendimentos",
    //   type: "link",
    //   perfil: ["99"],
    // },
    {
      path: "/atendimentos/listar",
      icon: "file-text",
      title: "Atendimentos",
      type: "link",
      perfil: ["99"],
    },
    // {
    //   path: "/atendimentos/cadastrados",
    //   icon: "file-text",
    //   title: "Atendimentos Cadastrados",
    //   type: "link",
    // },
    {
      title: "Cadastros Básicos",
      icon: "home",
      type: "sub",
      active: false,
      perfil: ["1", "3", "5", "6", "9"],
      children: [
        {
          path: "/numerosuporte",
          icon: "help-circle",
          title: "Número Suporte",
          type: "link",
        },
        {
          path: "/cliente",
          icon: "help-circle",
          title: "Clientes",
          type: "link",
        },
        {
          path: "/solicitante",
          icon: "help-circle",
          title: "Solicitantes",
          type: "link",
        },
        {
          path: "/sistema",
          icon: "help-circle",
          title: "Sistemas",
          type: "link",
        },
        {
          path: "/rotina",
          icon: "help-circle",
          title: "Rotinas",
          type: "link",
        },
        {
          path: "/motivo",
          icon: "help-circle",
          title: "Motivos",
          type: "link",
        },
        {
          path: "/usuario",
          icon: "help-circle",
          title: "Usuários",
          type: "link",
        },
      ],
    },
    {
      title: "Relatórios",
      icon: "file-text",
      type: "sub",
      active: false,
      perfil: ["1", "3", "5", "7"],
      children: [
        {
          path: "/relatorio/atendimento",
          icon: "help-circle",
          title: "Atendimento",
          type: "link",
          perfil: ["1", "3", "5"],
        },
        {
          path: "/relatorio/atendimentoporsetor",
          icon: "help-circle",
          title: "Atendimento por Setor",
          type: "link",
          perfil: ["1", "3", "5"],
        },
        {
          path: "/relatorio/atendimentoporcliente",
          icon: "help-circle",
          title: "Atendimento por Cliente",
          type: "link",
          perfil: ["1", "3", "5"],
        },
        {
          path: "/relatorio/movimentacoesdetalhadas",
          icon: "help-circle",
          title: "Detalhamento do Atendimento",
          type: "link",
          perfil: ["1", "3", "5"],
        },
        {
          path: "/relatorio/movimentacoesdetalhadasmodelo2",
          icon: "help-circle",
          title: "Detalhamento do Atendimento Modelo 2",
          type: "link",
          perfil: ["1", "3", "5"],
        },
        {
          path: "/relatorio/pormovimentacao",
          icon: "help-circle",
          title: "Por Movimentação",
          type: "link",
          perfil: ["1", "3", "5"],
        },
        {
          path: "/relatorio/diasaberto",
          icon: "help-circle",
          title: "Por Dias em Aberto",
          type: "link",
          perfil: ["1", "3", "5"],
        },
        {
          path: "/relatorio/gasto",
          icon: "help-circle",
          title: "Gasto",
          type: "link",
          perfil: ["1", "7"],
        },
      ],
    },
    {
      title: "Financeiro",
      icon: "dollar-sign",
      type: "sub",
      active: false,
      perfil: ["1", "6", "7", "9"],
      children: [
        {
          path: "/gastos/listar",
          icon: "dollar-sign",
          title: "Gastos",
          type: "link",
        },
        {
          path: "/diatrabalhado/listar",
          icon: "dollar-sign",
          title: "Dia Trabalhado",
          type: "link",
        },
        {
          path: "/lancamentos/listar",
          icon: "dollar-sign",
          title: "Lançamento Financeiro",
          type: "link",
          perfil: ["1", "6", "7", "9"],
        },
        {
          path: "/lancamentos/saldofinanceiro",
          icon: "dollar-sign",
          title: "Saldo Financeiro",
          type: "link",
          perfil: ["1", "6", "7", "9"],
        },
      ],
    },
  ];
  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
